"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Restrictions = void 0;
var Restrictions;
(function (Restrictions) {
    Restrictions["DOCUMENT_WITH_SMS_AUTHORIZATION"] = "DOCUMENT_WITH_SMS_AUTHORIZATION";
    Restrictions["DOCUMENT_WITH_SIGNATURE_ORDER"] = "DOCUMENT_WITH_SIGNATURE_ORDER";
    Restrictions["API_CLIENT_MANAGEMENT"] = "API_CLIENT_MANAGEMENT";
    Restrictions["DOCUMENT_WITH_APPROVER"] = "DOCUMENT_WITH_APPROVER";
    Restrictions["ORGANIZATION_DEFAULT_DOCUMENT_TAGS"] = "ORGANIZATION_DEFAULT_DOCUMENT_TAGS";
    Restrictions["DOCUMENT_MESSAGE_TEMPLATES_CREATION"] = "DOCUMENT_MESSAGE_TEMPLATES_CREATION";
    Restrictions["DOCUMENT_TAGS"] = "DOCUMENT_TAGS";
    Restrictions["DOCUMENT_WITH_ORGANIZATION_LOGO"] = "DOCUMENT_WITH_ORGANIZATION_LOGO";
    Restrictions["DOCUMENT_WITH_REVIEWER"] = "DOCUMENT_WITH_REVIEWER";
    Restrictions["DOCUMENT_HANDOVER"] = "DOCUMENT_HANDOVER";
    Restrictions["DOCUMENTS_BOARD"] = "DOCUMENTS_BOARD";
    Restrictions["ADDRESS_BOOK"] = "ADDRESS_BOOK";
    Restrictions["DOCUMENT_SENDING"] = "DOCUMENT_SENDING";
})(Restrictions = exports.Restrictions || (exports.Restrictions = {}));
